import { doLogin, getRtUserDetailsRefresh } from '@/api/auth'
import { clearAuthStorage, getToken, getUserInfo, setToken, setUserInfo } from '@/utils/auth'

const state = {
  token: getToken() || '',
  userInfo: getUserInfo() || null
}

const mutations = {
  SET_TOKEN (state, token) {
    state.token = token || ''
  },
  SET_USER_INFO (state, userInfo) {
    state.userInfo = userInfo || null
  }
}

const actions = {
  async login ({ commit }, form) {
    const res = await doLogin(form)
    const userInfo = res.data || {}
    // userAes 是后端生成的加密凭证，后续请求统一放入 userreportpack 请求头。
    const token = userInfo.userAes || ''
    setToken(token)
    setUserInfo(userInfo)
    commit('SET_TOKEN', token)
    commit('SET_USER_INFO', userInfo)
    return userInfo
  },
  async refreshUserInfo ({ commit, state }) {
    if (!state.token) {
      return null
    }
    // 刷新用户信息时顺带刷新角色权限树，保证菜单权限以服务端最新配置为准。
    const res = await getRtUserDetailsRefresh()
    const userInfo = res.data || {}
    const token = state.token || userInfo.userAes || ''
    setToken(token)
    setUserInfo(userInfo)
    commit('SET_TOKEN', token)
    commit('SET_USER_INFO', userInfo)
    return userInfo
  },
  logout ({ commit }) {
    clearAuthStorage()
    commit('SET_TOKEN', '')
    commit('SET_USER_INFO', null)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
